import { GET_COUPON } from '../actionTypes';

export default function(state = {}, action) {
    switch (action.type) {
        case GET_COUPON:
            return action.payload;
        default:
            return state;
    }
}
